var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.68 16.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #898989;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u6587\\u5B57",
    "data-name": "\\u6587\\u5B57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,1.35H1.68c-.09,0-.17.04-.24.1-.06.06-.1.15-.1.24v13.31c0,.09.04.17.1.24.06.06.15.1.24.1h15.31c.09,0,.18-.04.24-.1.06-.06.1-.15.1-.24V1.69c0-.09-.04-.18-.1-.24-.06-.06-.15-.1-.24-.1h0ZM1.68,0h15.31c.46,0,.89.19,1.19.49.31.31.49.73.49,1.19v13.31c0,.46-.19.88-.49,1.19-.3.31-.73.49-1.19.49H1.68c-.46,0-.88-.19-1.19-.49-.31-.31-.49-.73-.49-1.19V1.69c0-.47.19-.89.49-1.19.31-.31.73-.49,1.19-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.43,14.6c-.2,0-.36-.16-.36-.36v-.31c0-.32,0-.39.15-.56l4.68-5.79c.1-.13.25-.2.42-.21.16,0,.32.06.43.18l2.83,3,1.27-1.08.03-.03c.1-.08.23-.12.36-.11.13,0,.25.06.35.15l.03.03,3.92,4.09c.08.09.08.07.08.21v.42c0,.2-.16.36-.35.36H2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.92,3.12c.39-.39.93-.63,1.52-.63s1.13.24,1.52.63c.39.39.63.93.63,1.52s-.24,1.13-.63,1.52c-.39.39-.93.63-1.52.63s-1.13-.24-1.52-.63c-.39-.39-.63-.93-.63-1.52s.24-1.13.63-1.52h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.442befd5c0f59f82e8fb97dedb2ecb5b.svg";
export { ForwardRef as ReactComponent };